export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const SET_ACTIVITY_MATRIX = 'SET_ACTIVITY_MATRIX';
export const SET_ACTIVITY_RANKING = 'SET_ACTIVITY_RANKING';
